const errorTooltipClasses = {
  container: 'contact__message-container',
  text: 'contact__error-text',
};

const removeErrorTooltip = (element, classNames = {}) => {
  const classes = { ...errorTooltipClasses, ...classNames };
  Array.from(
    element.getElementsByClassName(classes.container),
  ).forEach((tooltipElement) => element.removeChild(tooltipElement));
};

const addErrorTooltip = (element, error, classNames = {}) => {
  removeErrorTooltip(element);

  const classes = { ...errorTooltipClasses, ...classNames };
  const tooltip = document.createElement('div');
  const tooltipText = document.createElement('div');

  tooltip.className = classes.container;
  tooltipText.className = classes.text;
  tooltipText.innerHTML = error;

  tooltip.appendChild(tooltipText);
  element.appendChild(tooltip);
};

export const errorTooltip = {
  add: addErrorTooltip,
  remove: removeErrorTooltip,
};
